import React from "react"

export default (projects, name) => {
  const [Items, setItems] = React.useState([])
  const [tag, setTag] = React.useState("All")

  if (projects === undefined || projects.length === 0) {
    return
  }
  
  React.useEffect(() => {
    async function filterNewProject() {
      let Filtered = []
      if (tag === "All") {
        Filtered = await projects
      } else if (name === "stack") {
        Filtered = await projects.filter(project =>
          project.stack
          .map((item ,index )=> {
              return item.title
            })
            .includes(tag)
        )
      } else {
        Filtered = await projects.filter(project => project.category === tag)
      }
      return Filtered
    }
    filterNewProject()
      .then(data => setItems(data))
      .catch(e => console.log(e))
  }, [tag, projects, name])

  return [Items, tag, setTag]
}
